<mat-card class="home mat-elevation-z3">
  <mat-card-title class="title"> Bem-vindo!</mat-card-title>
  <mat-card-subtitle class="subtitle">
    Sistema para exemplificar o sistema de um cadastro em
    Angular.</mat-card-subtitle
  >
  <ul>
    <li *myFor="let n em [1,2,3]">{{n}}</li>
  </ul>
</mat-card>
